import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  FetchListOrgCanSellProductRequest,
  fetchListOrgCanSellProductApi,
  IContentOrg,
} from 'api/productApi'
import {RootState} from 'store'

export const handleGetListOrgCanSellProduct = createAsyncThunk(
  'org/getListOrgCanRegister',
  async (payload: FetchListOrgCanSellProductRequest, {rejectWithValue}) => {
    try {
      const response = await fetchListOrgCanSellProductApi(payload)
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)
interface OrgCanRegisterParam {
  page: number
  size: number
  orgName: string
  email: string
}

interface OrgCanRegisterState {
  loading: boolean
  error: unknown
  query: OrgCanRegisterParam
  listOrgCanRegister: IContentOrg[] | []
  totalPages: number
}

const initialState: OrgCanRegisterState = {
  loading: false,
  error: undefined,
  query: {
    page: 0,
    size: 10,
    orgName: '',
    email: '',
  },
  listOrgCanRegister: [],
  totalPages: 0,
}

export const orgCanRegisterSlice = createSlice({
  name: 'orgCanRegister',
  initialState,
  reducers: {
    changeQuerySearch: <K extends keyof OrgCanRegisterParam>(
      state: OrgCanRegisterState,
      action: PayloadAction<{key: K; value: OrgCanRegisterParam[K]}>,
    ) => {
      state.query[action.payload.key] = action.payload.value
    },
    resetQuery: (state) => {
      state.query = initialState.query
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleGetListOrgCanSellProduct.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListOrgCanSellProduct.fulfilled, (state, action) => {
        state.loading = false
        state.listOrgCanRegister = action.payload.page.content
        state.totalPages = action.payload.page.totalPages
      })
      .addCase(handleGetListOrgCanSellProduct.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const {changeQuerySearch, resetQuery} = orgCanRegisterSlice.actions

export default orgCanRegisterSlice.reducer

export const selectLoading = (state: RootState) => state.orgCanRegister.loading
export const selectQuery = (state: RootState) => ({
  page: state.orgCanRegister.query.page,
  size: state.orgCanRegister.query.size,
  orgName: state.orgCanRegister.query.orgName,
  email: state.orgCanRegister.query.email,
})
export const selectError = (state: RootState) => state.orgCanRegister.error
export const selectTotalPages = (state: RootState) =>
  state.orgCanRegister.totalPages

export const selectListOrgCanRegister = (state: RootState) =>
  state.orgCanRegister.listOrgCanRegister
